<script lang="ts">
    import MealyTransition from './MealyTransition.svelte';
    import { setGetSVG, setPositionInPane } from '../createContext';
    import type { Vector } from '../Vector';
    import { pane_setScale, pane_setShowParameters, pane_setTranslation, select_deselect } from '../actions/ui';
    import BasePane from '../basePane/BasePane.svelte';
    import { machineProgramState_addState } from '../state/machineProgramState';
    import { getUpdateMachineState } from './context';
    import MealyNode from './MealyNode.svelte';
    import MealyTransitionSingleNode from './MealyTransitionSingleNode.svelte';
    import type { MachineStateMealy } from '../state/machineState';
    import { EditMode } from '../state/uiState';
    import TransitionWhileAdding from '../TransitionWhileAdding.svelte';
    import { grid_fitVector } from '../grid';
    import { getGetSVG, getZoomToFit } from '../context';
    import ArrowMarker from '../ArrowMarker.svelte';
    
    export let machineState: MachineStateMealy;
    export let editMode: EditMode;

    $: uiState = machineState.uiState;
    $: machine = machineState.machine;

    let basePane;

    function positionInPane(x: number, y: number) {
        return basePane.positionInPane(x, y);
    }

    setPositionInPane(positionInPane);

    function getSVG() {
        return basePane.getSVG();
    }

    const getSVGStore = getGetSVG();
    getSVGStore.set(getSVG);

    const zoomToFitStore = getZoomToFit();
    zoomToFitStore.set(() => basePane.zoomToFit());

    let pointerPosition: Vector = {x: 0, y: 0}

    function handlePaneClicked(event: MouseEvent, position: Vector) {
        // console.log('MealyPane - click');
        if (editMode === EditMode.ADD_STATE) {
            const newMachineState = machineProgramState_addState(machineState, grid_fitVector(position));
            updateMachineProgramState(newMachineState);
        } else if (editMode === EditMode.NEUTRAL) {
            updateMachineProgramState(select_deselect(machineState));
        }
    }

    const updateMachineProgramState = getUpdateMachineState();

    function handleShowParametersChange(scale: number, translation: Vector) {
        updateMachineProgramState(pane_setShowParameters(machineState, scale, translation));
    }
</script>

<BasePane
    bind:this={basePane}
    
    onClick={handlePaneClicked}
    onPrimaryPointerMove={pos => pointerPosition = pos}

    onShowParametersChange={handleShowParametersChange}

    onScaleChange={scale => updateMachineProgramState(pane_setScale(machineState, scale))}
    onTranslationChange={translation => updateMachineProgramState(pane_setTranslation(machineState, translation))}

    translation={uiState.pane.translation}
    scale={uiState.pane.scale}
>
    <ArrowMarker />
    {#each Object.values(machine.transitions) as transition (transition.id)}
        {#if transition.fromNodeId === transition.toNodeId}
            <MealyTransitionSingleNode transition={transition} machineState={machineState} />
        {:else}
            <MealyTransition transition={transition} machineState={machineState} />
        {/if}
    {/each}

	{#each Object.values(machine.nodes) as node (node.id)}
        <MealyNode node={node} machineState={machineState} />
    {/each}

    {#if editMode === EditMode.ADD_TRANSITION && typeof uiState.addTransition.fromNodeId === 'string'}        
        <TransitionWhileAdding
            fromPosition={ {x: machine.nodes[uiState.addTransition.fromNodeId].posx, y: machine.nodes[uiState.addTransition.fromNodeId].posy} }
            toPosition={pointerPosition}
        />
    {/if}
</BasePane>